import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter([
  {
    path: "/login",
    lazy: async () => ({ Component: (await import("./pages/Login")).Login }),
  },
  {
    path: "/activate",
    lazy: async () => ({ Component: (await import("./pages/Activate")).Activate }),
  },
  {
    path: "/me",
    lazy: async () => ({ Component: (await import("./pages/MyAssessments")).MyAssessments }),
  },
  {
    path: "/",
    lazy: async () => ({ Component: (await import("./pages/MyAssessments")).MyAssessments }),
  },
  {
    path: "*",
    lazy: async () => ({ Component: (await import("./pages/NotFound")).NotFound }),
  },
]);
